import http from '@/http'

const TRACKING_TOKEN_KEY = 'schedulingTrackingToken'

class SchedulingService {
    async post(data: any) {
        const response = await http.post('agendamento/novo', data, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        })
        return response
    }

    async loginTracking(data: any) {
        return http.post('agendamento/acompanhar/login', data)
    }

    private trackingHeaders() {
        const token = this.getTrackingToken()

        return {
            Authorization: `Bearer ${token}`,
            'Cache-Control': 'no-store',
        }
    }

    async getTrackingConfirmation() {
        return (await http.get('agendamento/acompanhar/confirmacao', { headers: this.trackingHeaders() })).data
    }
    async putTrackingConfirmation(data: FormData) {
        return http.put('agendamento/acompanhar/confirmacao', data, { headers: this.trackingHeaders() })
    }

    async getTrackingStatus() {
        return http.get('agendamento/acompanhar/status', {
            headers: this.trackingHeaders()
        })
    }

    async getTeacherSurvey() {
        return http.get('agendamento/acompanhar/pesquisa', {
            headers: this.trackingHeaders()
        })
    }

    async submitTeacherSurvey(answers: any[], cpfTeacher?: string, versionSurvey?: number, formRevision?: string) {
        return http.post(
            'agendamento/acompanhar/pesquisa',
            { answers, cpfTeacher: cpfTeacher || undefined, versionSurvey, formRevision },
            { headers: this.trackingHeaders() }
        )
    }

    async downloadTeacherCertificate() {
        return http.get('agendamento/acompanhar/certificado', {
            headers: this.trackingHeaders(),
            responseType: 'blob'
        })
    }

    async validateTeacherCertificate(token: string) {
        return http.get(
            `agendamento/certificado-professor/validar/${encodeURIComponent(token)}`,
            {
                headers: {
                    'Cache-Control': 'no-store',
                }
            }
        )
    }

    saveTrackingToken(token: string) {
        sessionStorage.setItem(TRACKING_TOKEN_KEY, token)
    }

    getTrackingToken() {
        return sessionStorage.getItem(TRACKING_TOKEN_KEY)
    }

    clearTrackingToken() {
        sessionStorage.removeItem(TRACKING_TOKEN_KEY)
    }

    async getList() {
        const response = await http.get('agendameto/lista')
        return response
    }
    async getCorrecao(filter: string) {
        const response = await http.get(`agendamento/correcao/${filter}`)
        return response.data
    }
    async getConfirmacao(url: string) {
        const response = await http.get(`agendamento/confirmacao/${url}`)
        return response.data
    }
    async putCorrecao(data: any, url: string) {
        const response = await http.put(`agendamento/correcao/${url}`, data)
        return response
    }
    async putConfirmacao(data: any, url: string) {
        const response = await http.put(`agendamento/confirmacao/${url}`, data, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        })
        return response
    }
}

export default new SchedulingService()
